import React from "react";
import { i18n } from "../../translate/i18n";

const TicketInfo = ({ contact, ticket, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="flex items-center gap-3 cursor-pointer hover:bg-dark-100 dark:hover:bg-dark-800 rounded-lg px-2 py-1.5 transition-colors"
    >
      {/* Avatar */}
      {contact.profilePicUrl ? (
        <img
          src={contact.profilePicUrl}
          alt={contact.name}
          className="w-10 h-10 rounded-full object-cover flex-shrink-0"
        />
      ) : (
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary-400 to-primary-600 flex items-center justify-center text-white font-semibold text-sm flex-shrink-0">
          {contact.name?.charAt(0)?.toUpperCase() || "?"}
        </div>
      )}

      {/* Info */}
      <div className="min-w-0">
        <h3 className="text-sm font-semibold text-dark-900 dark:text-white truncate leading-tight">
          {contact.name}
          <span className="text-dark-400 dark:text-dark-500 font-normal ml-2">
            #{ticket.id}
          </span>
        </h3>
        {ticket.user && (
          <p className="text-xs text-dark-500 dark:text-dark-400 truncate leading-tight">
            {i18n.t("messagesList.header.assignedTo")} {ticket.user.name}
          </p>
        )}
      </div>
    </div>
  );
};

export default TicketInfo;
